import { render, staticRenderFns } from "./__SocialTrafficTable.vue?vue&type=template&id=1a3f045e&"
import script from "./__SocialTrafficTable.vue?vue&type=script&lang=js&"
export * from "./__SocialTrafficTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports